import { useQuery } from 'react-apollo';

import { PricingCategories } from '../../../graphql/queries/pricing-categories';

const usePricingCategories = () => {
  const { data: { pricingCategories } = {}, loading } = useQuery(
    PricingCategories,
    { fetchPolicy: 'cache-first' },
  );

  return {
    loadingCategories: loading,
    pricingCategories: pricingCategories?.records ?? [],
  };
};

export default usePricingCategories;
